<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Køretøj" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<select-view label="Afdeling" v-model="entity.department_id" :options="departments" optionValueName="id" />
				</div>
				<div v-show="active == 'details'">
					<string-view label="Navn" v-model="entity.name" />
					<string-view :optional="true" label="Registreringsnummer" v-model="entity.reg_no" />
				</div>
				<div v-show="active == 'details'">
					<div class="side-window__heading">
						Vis i planlægning
						<switch-view v-model="entity.planning" />
					</div>					
				</div>
				<div v-show="active == 'details'">
					<div class="side-window__heading">
						Vis i tracking
						<switch-view v-model="entity.tracking" />
					</div>					
				</div>
				<div v-show="active == 'details'">
					<string-view :optional="true" label="Mærke" v-model="entity.make" />
					<string-view :optional="true" label="Model" v-model="entity.model" />
				</div>
				<div v-show="active == 'details'">
					<string-view :optional="true" label="Længde" v-model="entity.length" />
					<string-view :optional="true" label="Bredde" v-model="entity.width" />
					<string-view :optional="true" label="Højde" v-model="entity.height" />
				</div>
				<div v-show="active == 'details'">
					<string-view :optional="true" label="Omkostning pr time (privat)" v-model="entity.cost_hr" />
					<string-view :optional="true" label="Omkostning pr km (privat)" v-model="entity.cost_km" />
				</div>
				<div v-show="active == 'details'">
					<string-view :optional="true" label="Omkostning pr time (erhverv)" v-model="entity.cost_hr_biz" />
					<string-view :optional="true" label="Omkostning pr km (erhverv)" v-model="entity.cost_km_biz" />
				</div>
				<div v-for="(role, i) in roles" v-bind:key="'roles' + i" v-show="active == 'roles'">
					<div class="side-window__heading">
						{{ role.label }}
						<switch-view v-model="entity.roles[role.name].enabled" />
					</div>
					<div v-for="(prop, j) in role.props" v-bind:key="j" class="side-window__heading small" v-show="entity.roles[role.name].enabled" :style="{
						marginBottom: '20px',
						height: prop.type == 'SwitchView' ? '30px' : '52px'
					}">
						{{ prop.type == 'SwitchView' ? prop.label : '' }}
						<component :optional="true" :is="prop.type" :label="prop.label" v-model="entity.roles[role.name]['props'][prop.name]" />
					</div>
				</div>
			</form-grid-layout>
		</div>
		<div v-if="!id" slot="footer">
			<button-view label="Opret" @click="create" />
		</div>
		<div v-if="form && id" slot="footer">
			<button-view label="Gem" @click="update" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import SwitchView from '../views/SwitchView';

	export default {
		data: function () {
			return {
				entity: {
					name: null,
					reg_no: null,
					make: null,
					model: null,
					length: null,
					width: null,
					height: null,
					roles: {},
					department_id: null
				},
				active: 'details',
				roles: [],
				departments: []
			};
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'SwitchView': SwitchView
		},
		computed: {
			_roles() {
				var r = {};
				var role;
				var props;
				var prop;

				for (var i = 0; i < this.roles.length; ++i) {
					role = this.roles[i];
					props = {};
					
					for (var j = 0; j < role.props.length; ++j) {
						prop = role.props[j];
						props[prop.name] = prop.default;
					}

					r[role.name] = {
						enabled: false,
						props: props
					};
				}

				return r;
			},
			tabs: function () {
				if (this.id) {
					return [
						{
							name: 'details',
							label: 'Detaljer'
						},
						{
							name: 'roles',
							label: 'Roller'
						},
						/*{
							name: 'contacts',
							label: 'Contacts'
						}*/
					];
				} else {
					return [
						{
							name: 'details',
							label: 'Detaljer'
						},
						{
							name: 'roles',
							label: 'Roller'
						}
					];
				}
			}
		},
		props: {
			id: Number,
			form: Boolean,
			onCreate: {
				type: Function,
				default: function () {}
			},
			onUpdate: {
				type: Function,
				default: function () {}
			},
			onChange: {
				type: Function,
				default: function () {}
			}
		},
		methods: {
			invoiceSelect(name, id, label) {
				
				
				

				this.input(name, id);
			},
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			create() {
				var win = this;

				
				

				this.axios
					.post('/fleet/vehicles/', this.entity)
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							win.onCreate(r.data);
							win.onChange(r.data);
							win.$store.state.windowStack.pop();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});		
			},
			update() {
				
				

				var win = this;

				this.axios
					.put('/fleet/vehicles/' + this.id + '/', this.entity)
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							win.onCreate(r.data);
							win.onChange(r.data);
							win.$store.state.windowStack.pop();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			input(name, value) {
				this.entity[name] = value;
			}
		},
		mounted: function() {
			
			

			var self = this;

			this.axios
				.get('/us/vehicles/roles/')
				.then(function (r) {
					self.roles = r.data._items;
					self.entity.roles = {...self._roles, ...self.entity.roles};
				});

			if (this.id) {
				this.axios
					.get('/fleet/vehicles/' + this.id + '/')
					.then(function (r) {
						self.entity = r.data;
						self.entity.roles = {...self._roles, ...self.entity.roles};
					});
			}

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.departments = r.data._items;
				});
		}
	}
</script>

<style lang="scss">
	
</style>
